
import Vue from 'vue';

/**
 * The expandable Filters box: the header, the grid the fields sit in, and the
 * Cancel and Apply Filters bar, opened by a <filter-toggle-button>. The fields
 * are the host's, passed as the default slot, and the host keeps them as a
 * draft: this box only says which button was pressed. So the host decides what
 * Apply commits, what Cancel restores, and what Clear all resets.
 *
 * Give each field `class="filter-field"`, plus `filter-field--has-value` while
 * it holds a value, and it takes the box's raised look. A field placed in the
 * `scope` slot sits in its own row above the grid.
 */
export default Vue.extend({
	name: 'FiltersPanel',
	props: {
		expanded: { type: Boolean, default: false },
		// How many filters the draft holds, shown beside the title.
		activeCount: { type: Number, default: 0 },
		// Whether Clear all is offered.
		canClear: { type: Boolean, default: false },
		applyDisabled: { type: Boolean, default: false },
		// Drop the rail and use a flatter surface, for a host whose own background differs.
		flat: { type: Boolean, default: false },
		ariaLabel: { type: String, default: 'Filters' },
		// The narrowest a field may get, in px, before the grid wraps it to the next row. A host
		// whose fields hold long values (an address) asks for more than the default.
		fieldMinWidth: { type: Number, default: null },
	},
	computed: {
		gridStyle (): Record<string, string> {
			return this.fieldMinWidth
				? { gridTemplateColumns: `repeat(auto-fill, minmax(${this.fieldMinWidth}px, 1fr))` }
				: {};
		},
	},
});
